import {kSystemIcons} from "../../../constants/icons";

export default function GamesTimerBadge() {
    // Used in

    // BUILD
    return (
        <div className={"bg-primary/30 flex justify-center items-center rounded-[12px] w-[40px] min-w-[40px] h-[40px] min-h-[40px]"}>
            <i className="material-icons text-[24px] text-primary">
                {kSystemIcons.timer}
            </i>
        </div>
    );
}